import { route } from "../../service/routeDictionary";
import API from "../../service/api";
import { environment } from "../../environments/env";

const state = {
  statusCode: 0,
  isError: [],
  isLoadingPost: false,
  storeSelected: [],
  instaMidiaContainer:
    localStorage.getItem("instaMidiaContainer") != null
      ? JSON.parse(localStorage.getItem("instaMidiaContainer"))
      : [],
  instaMidiaPosts:
    localStorage.getItem("instaMidiaPosts") != null
      ? JSON.parse(localStorage.getItem("instaMidiaPosts"))
      : [],
};

const getters = {
  getInstaMidiaContainer: (state) => state.instaMidiaContainer,
  getInstaMidiaPosts: (state) => state.instaMidiaPosts,
  getStores: (state) => state.storeSelected,
  isLoadingPost: (state) => state.isLoadingPost,
  isErrorGetter: (state) => state.isError,
  handleStatusCode: (state) => state.statusCode,
};

const actions = {
  async uploadMediaToContainerBatch({ commit }, collection) {
    commit("set_Insta_Midia_Container", collection);
  },
  async registerPostBatch({ commit }, posts) {
    commit("set_Register_Posts", posts);
  },

  isLoadingPostSet({ commit }, isLoading) {
    commit("set_isLoading", isLoading);
  },

  async hasError({ commit }, isError) {
    commit("set_hasError", isError);
  },
};

const mutations = {
  set_isLoading(state, isLoading) {
    state.isLoadingPost = isLoading;
  },

  set_hasError(state, error) {
    state.isError = error;
  },

  async set_Insta_Midia_Container(state, collection) {
    state.isLoadingPost = true;

    let type = collection.midias ? "midias" : "template";
    let stores = collection.post.storeSelected;
    state.storeSelected = stores;
    let isCarousel = collection.container
      ? collection.container.mediasContainers[0].flagCarousel
      : 0;
    let batchMedia = [];

    let scheduled = [];
    scheduled.push(collection.post);

    for (let [i, store] of stores.entries()) {
      i;
      let containerCreate = {};
      if (type === "midias") {
        if (scheduled[0].date && scheduled[0].time) {
          let date = new Date(scheduled[0].date);
          let dateFormat = date.toISOString().split("T");
          let mountedDate = `${dateFormat[0]}T${scheduled[0].time}:00.00Z`;

          containerCreate = {
            caption: collection.container.caption,
            instaPageId: store,
            scheduleDate: mountedDate,
            mediaType:
              collection.container.mediaType == "VIDEO"
                ? "REELS"
                : collection.container.mediaType,
            mediasContainers: [],
          };
        } else {
          containerCreate = {
            caption: collection.container.caption,
            instaPageId: store,
            mediaType:
              collection.container.mediaType == "VIDEO"
                ? "REELS"
                : collection.container.mediaType,
            mediasContainers: [],
          };
        }

        for (let [index, el] of collection.midias.entries()) {
          index;
          if (el) {
            containerCreate.mediasContainers.push({
              flagCarousel: isCarousel,
              mediaUrl: `${el.url}`,
            });
          }
        }
      } else {
        if (scheduled[0].date && scheduled[0].time) {
          let date = new Date(scheduled[0].date);
          let dateFormat = date.toISOString().split("T");
          let mountedDate = `${dateFormat[0]}T${scheduled[0].time}:00.00Z`;
          let type =
            collection.templates[0].templateFile.includes(".jpg") ||
            collection.templates[0].templateFile.includes(".jpeg")
              ? "IMAGE"
              : "REELS";

          containerCreate = {
            caption: collection.post.caption,
            instaPageId: store,
            scheduleDate: mountedDate,
            mediaType: type,
            mediasContainers: [],
          };
        } else {
          let type =
            collection.templates[0].templateFile.includes(".jpg") ||
            collection.templates[0].templateFile.includes(".jpeg")
              ? "IMAGE"
              : "REELS";

          containerCreate = {
            caption: collection.post.caption,
            instaPageId: store,
            mediaType: type,
            mediasContainers: [],
          };
        }

        for (let [index, el] of collection.templates.entries()) {
          index;
          if (el) {
            containerCreate.mediasContainers.push({
              flagCarousel: isCarousel,
              mediaUrl: el.templateFile,
            });
          }
        }
      }

      batchMedia.push(containerCreate);
      state.instaMidiaContainer = batchMedia;
    }
  },

  async set_Register_Posts(state, posts) {
    let responses = [];

    for (let i = 0; i < posts.length; i++) {
      if (posts[i].scheduleDate) {
        responses.push(
          API.post(
            `${environment.apiUri}${route.InstagramMediaScheduleV2}`,
            posts,
            {
              headers: { "Content-Type": "application/json" },
            }
          )
        );
      } else {
        responses.push(
          API.post(
            `${environment.apiUri}${route.InstagramPostMediaV2}`,
            posts,
            {
              headers: { "Content-Type": "application/json" },
            }
          )
        );
      }

      break;
    }

    Promise.all(responses)
      .then((resolve) => {
        state.isLoadingPost = true;

        for (let i = 0; i < resolve.length; i++) {
          if (resolve[i].status === "fulfilled" || resolve[i].status === 200) {
            setTimeout(() => {
              localStorage.setItem("status", 200);
              state.statusCode = 200;
              state.instaMidiaPosts = resolve[i];
            }, 1000);

            setTimeout(() => {
              state.isLoadingPost = false;
            }, 3000);
          }
        }
      })
      .catch((err) => {
        state.isError = { err, erro: true };
      });
  },
};

export default {
  state,
  actions,
  getters,
  mutations,
};
